// import "bagstage-ui-library/styles"; // TODO: uncomment later
import { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import useAuth from "./hooks/useAuth";
import { ErrorPage } from "./pages/ErrorPage";
import RedirectToArrivalAnalyst from "./pages/RedirectToArrivalAnalyst";
import RedirectToArrivalOperator from "./pages/RedirectToArrivalOperator";
import RedirectToDepartureAnalyst from "./pages/RedirectToDepartureAnalyst";
import RedirectToDepartureOperator from "./pages/RedirectToDepartureOperator";
import RedirectToTransferQTB from "./pages/RedirectToTransferQTB";
import RedirectToUserManagement from "./pages/RedirectToUserManagement";
import { addKeycloakInterceptorWithKeycloakInstance } from "./service/api";
import "./service/translations/translationService";
import { getEnabledProducts } from "./store/enabledProducts/action";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import RedirectToArrivalCustoms from "./pages/RedirectToArrivalCustoms";
import MainPage from "./pages/MainPage";
import { useRefreshCheck } from "./hooks/useRefreshCheck";
import RefreshOnNewBuildService from "./service/refreshOnBuildService";

const router = createBrowserRouter([
  { path: "/", element: <MainPage /> },
  { path: "/user-management", element: <RedirectToUserManagement /> },
  { path: "/arrival-analyst", element: <RedirectToArrivalAnalyst /> },
  { path: "/arrival-customs", element: <RedirectToArrivalCustoms /> },
  { path: "/arrival-operator", element: <RedirectToArrivalOperator /> },
  { path: "/departure-operator", element: <RedirectToDepartureOperator /> },
  { path: "/transfer-qtb", element: <RedirectToTransferQTB /> },
  {
    path: "/bagstage-departure-chuteallocation-longterm-ui/perform_token_login",
    element: <RedirectToDepartureAnalyst />
  },
  { path: "error", element: <ErrorPage /> },
  { path: "*", element: <ErrorPage /> }
]);

const App = () => {
  const { login } = useAuth();
  const { kcObject } = useAppSelector((state) => state.authenticationSlice);
  const dispatch = useAppDispatch();
  const { shouldHardRefresh, terminate } = useRefreshCheck();

  useEffect(() => {
    if (login && kcObject) {
      addKeycloakInterceptorWithKeycloakInstance(kcObject);
      dispatch(getEnabledProducts());
    }
  }, [kcObject, login, dispatch]);

  useEffect(() => {
    if (shouldHardRefresh) {
      terminate();
      RefreshOnNewBuildService.forceReload();
    }
  }, [shouldHardRefresh]);

  return (
    <main>
      <RouterProvider router={router} />
    </main>
  );
};
export default App;
